export default __webpack_public_path__ + "static/media/favoriteIcon.f8a5aa01.svg";